/**
 * PKCE (RFC 7636) helpers for the Authorization Code flow used by the new
 * community_web_app OAuth2 client (D9). Web Crypto API only — no extra
 * dependency needed for random bytes or SHA-256.
 */

function base64UrlEncode(bytes: Uint8Array): string {
  let binary = '';
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return btoa(binary)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

/**
 * Cryptographically random, base64url string.
 * @param byteLength entropy in bytes before encoding (32 bytes = 256 bits, the
 *  RFC 7636-recommended minimum for a code_verifier).
 */
export function generateRandomString(byteLength: number = 32): string {
  const bytes = new Uint8Array(byteLength);
  window.crypto.getRandomValues(bytes);
  return base64UrlEncode(bytes);
}

/** SHA-256 code_challenge (S256 method) for a given code_verifier. */
export async function generateCodeChallenge(codeVerifier: string): Promise<string> {
  const data = new TextEncoder().encode(codeVerifier);
  const digest = await window.crypto.subtle.digest('SHA-256', data);
  return base64UrlEncode(new Uint8Array(digest));
}
